import { sideArguments } from "@/mocks/topic";

type Props = { sideA: string; sideB: string };

export default function SideCompare({ sideA, sideB }: Props) {
  return (
    <div>
      <h2 id="compare-title" className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
        双方观点对照
      </h2>
      <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
        下面把两派最有代表性的说法并排放出来。看完再投票，或者换个角度想想：有没有第三种可能？
      </p>

      <div className="mt-8 grid grid-cols-1 gap-6 xl:grid-cols-2">
        <div className="rounded-lg border border-primary-200 bg-primary-50/40 p-5 md:p-6">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-thumb-up-line text-lg" aria-hidden="true" />
            </span>
            <h3 className="font-heading text-lg font-bold text-foreground-950">{sideA}</h3>
          </div>
          <ul className="mt-5 space-y-4">
            {sideArguments.a.map((arg) => (
              <li key={arg.point} className="rounded-md bg-background-50 p-4">
                <h4 className="flex items-center gap-2 text-sm font-bold text-foreground-900">
                  <i className="ri-checkbox-blank-circle-fill text-[8px] text-primary-500" aria-hidden="true" />
                  {arg.point}
                </h4>
                <p className="mt-2 pl-4 text-sm leading-relaxed text-foreground-600">{arg.detail}</p>
              </li>
            ))}
          </ul>
        </div>

        <div className="rounded-lg border border-secondary-200 bg-secondary-50/40 p-5 md:p-6">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-500 text-background-50">
              <i className="ri-thumb-up-line text-lg" aria-hidden="true" />
            </span>
            <h3 className="font-heading text-lg font-bold text-foreground-950">{sideB}</h3>
          </div>
          <ul className="mt-5 space-y-4">
            {sideArguments.b.map((arg) => (
              <li key={arg.point} className="rounded-md bg-background-50 p-4">
                <h4 className="flex items-center gap-2 text-sm font-bold text-foreground-900">
                  <i className="ri-checkbox-blank-circle-fill text-[8px] text-secondary-500" aria-hidden="true" />
                  {arg.point}
                </h4>
                <p className="mt-2 pl-4 text-sm leading-relaxed text-foreground-600">{arg.detail}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}